<template>
  <v-dialog
    v-model="showModal"
    persistent
  >
    <v-card
      outlined
      color="#ECEFF1"
    >
      <v-card-title>
        <h2>Filter</h2>
      </v-card-title>
      <br>
      <v-card-text>
        <v-form
          ref="form"
          v-model="valid"
        >
          <!-- <v-select
            v-model="dateTypeSelected"
            light
            color="#37474F"
            flat
            dense
            :items="dateType"
            label="Date Type"
            outlined
            background-color="transparent"
            class="small-select"
            @change="selectedDateType"
          />
          <div v-if="enableDay">
            <v-dialog
              ref="fromDialog"
              v-model="fromCalendar"
              :return-value.sync="formData.date"
              width="290px"
            >
              <template #activator="{ on, attrs }">
                <v-text-field
                  v-model="formData.date"
                  placeholder="Select Date"
                  outlined
                  filled
                  readonly
                  background-color="transparent"
                  hint="Please select a date to filter"
                  color="#37474f"
                  dense
                  light
                  prepend-inner-icon="mdi-calendar-month-outline"
                  v-bind="attrs"
                  v-on="on"
                />
              </template>
              <v-date-picker
                v-if="fromCalendar"
                v-model="formData.date"
                full-width
                color="#37474F"
                light
                @input="$refs.fromDialog.save(formData.date)"
              >
                <v-spacer />
                <v-btn
                  text
                  color="#37474F"
                  @click="fromCalendar = false"
                >
                  Cancel
                </v-btn>
              </v-date-picker>
            </v-dialog>
          </div>
          <div v-if="enableDayRange">
            <v-row>
              <v-col cols="6">
                <v-dialog
                  ref="fromStartDialog"
                  v-model="fromStartCalendar"
                  :return-value.sync="formData.startDate"
                  width="290px"
                >
                  <template #activator="{ on, attrs }">
                    <v-text-field
                      v-model="formData.startDate"
                      placeholder="Start Date"
                      outlined
                      filled
                      readonly
                      background-color="transparent"
                      hint="Please select a date to filter"
                      color="#37474f"
                      dense
                      light
                      prepend-inner-icon="mdi-calendar-month-outline"
                      v-bind="attrs"
                      v-on="on"
                    />
                  </template>
                  <v-date-picker
                    v-if="fromStartCalendar"
                    v-model="formData.startDate"
                    full-width
                    color="#37474F"
                    light
                    @input="$refs.fromStartDialog.save(formData.startDate)"
                  >
                    <v-spacer />
                    <v-btn
                      text
                      color="#37474F"
                      @click="fromStartCalendar = false"
                    >
                      Cancel
                    </v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-col>
              <v-col cols="6">
                <v-dialog
                  ref="fromEndDialog"
                  v-model="fromEndCalendar"
                  :return-value.sync="formData.endDate"
                  width="290px"
                >
                  <template #activator="{ on, attrs }">
                    <v-text-field
                      v-model="formData.endDate"
                      placeholder="End Date"
                      outlined
                      filled
                      readonly
                      background-color="transparent"
                      hint="Please select a date to filter"
                      color="#37474f"
                      dense
                      light
                      :rules="validationRules"
                      prepend-inner-icon="mdi-calendar-month-outline"
                      v-bind="attrs"
                      v-on="on"
                    />
                  </template>
                  <v-date-picker
                    v-if="fromEndCalendar"
                    v-model="formData.endDate"
                    full-width
                    color="#37474F"
                    light
                    :min="formData.startDate"
                    :disabled="formData.startDate === ''"
                    @input="$refs.fromEndDialog.save(formData.endDate)"
                  >
                    <v-spacer />
                    <v-btn
                      text
                      color="#37474F"
                      @click="fromEndCalendar = false"
                    >
                      Cancel
                    </v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-col>
            </v-row>
          </div>
          <div v-if="enableMonth">
            <v-dialog
              ref="fromMonthDialog"
              v-model="fromMonthCalendar"
              :return-value.sync="formData.month"
              width="290px"
            >
              <template #activator="{ on, attrs }">
                <v-text-field
                  v-model="formData.month"
                  placeholder="Select Date"
                  outlined
                  filled
                  readonly
                  background-color="transparent"
                  hint="Please select a month to filter"
                  color="#37474f"
                  dense
                  light
                  prepend-inner-icon="mdi-calendar-month-outline"
                  v-bind="attrs"
                  v-on="on"
                />
              </template>
              <v-date-picker
                v-if="fromMonthCalendar"
                v-model="formData.month"
                full-width
                color="#37474F"
                light
                type="month"
                @input="$refs.fromMonthDialog.save(formData.month)"
              >
                <v-spacer />
                <v-btn
                  text
                  color="#37474F"
                  @click="fromMonthCalendar = false"
                >
                  Cancel
                </v-btn>
              </v-date-picker>
            </v-dialog>
          </div> -->
          <v-select
            v-model="formData.type"
            light
            color="#37474F"
            flat
            dense
            :items="type"
            item-text="name"
            item-value="id"
            label="Type"
            outlined
            background-color="transparent"
            class="small-select"
          />
          <v-select
            v-model="formData.status"
            light
            color="#37474F"
            flat
            dense
            :items="status"
            item-text="name"
            item-value="id"
            label="Status"
            outlined
            background-color="transparent"
            class="small-select"
          />
          <v-select
            v-model="formData.priority"
            light
            color="#37474F"
            flat
            dense
            :items="priority"
            item-text="name"
            item-value="id"
            label="Priority"
            outlined
            background-color="transparent"
            class="small-select"
          />
          <v-select
            v-model="formData.project"
            light
            color="#37474F"
            flat
            dense
            :items="organizationProjects"
            item-text="name"
            item-value="id"
            label="Project"
            outlined
            background-color="transparent"
            class="small-select"
          />
        </v-form>
        <div>
          <v-btn
            class="next-style"
            elevation="0"
            color="#64CA7F"
            @click="filter()"
          >
            Filter
          </v-btn>&nbsp;&nbsp;
          <v-btn
            class="cancel-style"
            elevation="0"
            color="#F5F5F5"
            @click="showModal = false"
          >
            Cancel
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import Constants from 'src/constants';
export default {
  name: 'FilterJobsDialog',
  data: () => ({
    showModal: true,
    valid: false,
    formData: {
      date: null,
      startDate: null,
      endDate: null,
      month: '',
      type: null,
      priority: null,
      project: null,
    },
    dateType: ['Custom', 'Day', 'Month'],
    type: [
      {
        name: 'Milestone',
        id: 'milestone',
      },
      {
        name: 'Task',
        id: 'task',
      },
      {
        name: 'Activity',
        id: 'activity',
      },
    ],
    priority: [
      {
        name: 'Low',
        id: 'low',
      },
      {
        name: 'Medium',
        id: 'medium',
      },
      {
        name: 'High',
        id: 'high',
      },
      {
        name: 'Critical',
        id: 'critical',
      },
    ],
    status: [
      {
        name: 'Pending',
        id: 'pending',
      },
      {
        name: 'Completed',
        id: 'completed',
      },
      {
        name: 'Suspended',
        id: 'suspended',
      },
      {
        name: 'Delayed',
        id: 'delayed',
      },
      {
        name: 'Active',
        id: 'active',
      },
    ],
    enableDay: false,
    enableDayRange: false,
    enableMonth: false,
    showFilterForm: false,
    fromCalendar: false,
    fromStartCalendar: false,
    fromEndCalendar: false,
    fromMonthCalendar: false,
    dateTypeSelected: '',
  }),
  computed: {
    validationRules () {
      if (this.formData.startDate !== '') {
        return [(v) => !!v || 'This field is required'];
      } else {
        return [];
      }
    },
    jobFilters () {
      return this.$store.getters['jobs/getJobFilters'];
    },
    organizationProjects () {
      return this.$store.getters['projects/getOrganizationProjects'];
    },
    selectedOrganization () {
      return this.$store.getters.getSelectedOrganization;
    },
  },
  watch: {
    showModal: function (newval, oldval) {
      if (newval === false) {
        this.$emit('closed');
      }
    },
  },
  mounted () {
    this.getOrganizationProjects();
    this.checkPreFilters();
  },
  methods: {
    selectedDateType (val) {
      if (val === 'Custom') {
        this.enableDayRange = true;
        this.enableDay = false;
        this.enableMonth = false;
      } else if (val === 'Day') {
        this.enableDay = true;
        this.enableDayRange = false;
        this.enableMonth = false;
      } else {
        this.enableMonth = true;
        this.enableDay = false;
        this.enableDayRange = false;
      }
      this.formData.date = null;
      this.formData.startDate = null;
      this.formData.endDate = null;
      this.formData.month = '';
    },
    async getOrganizationProjects () {
      this.loading = true;
      await this.$store.dispatch('projects/fetchOrganizationProjects', {
        organizationExtId: this.selectedOrganization.organization.external_id,
      });
      this.loading = false;
    },
    filter () {
      if (this.$refs.form.validate() === false) {
        this.$store.dispatch(
          'alert/onAlert',
          {
            message: 'Please fill the required fields before proceeding',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        return;
      }
      const data = {
        ...this.formData,
        dateTypeSelected: this.dateTypeSelected,
      };
      this.$store.dispatch('jobs/storeJobFilters', data);
      this.$emit('filterData', this.formData);
      this.showModal = false;
    },
    checkPreFilters () {
      this.formData.priority = this.jobFilters.priority;
      this.formData.type = this.jobFilters.type;
      this.formData.project = this.jobFilters.project;
      this.formData.status = this.jobFilters.status;

      if (this.jobFilters.dateTypeSelected === 'Month') {
        this.dateTypeSelected = 'Month';
        this.enableMonth = true;
        this.formData.month = this.jobFilters.month;
      }
      if (this.jobFilters.dateTypeSelected === 'Day') {
        this.dateTypeSelected = 'Day';
        this.enableDay = true;
        this.formData.date = this.jobFilters.date;
      }
      if (this.jobFilters.dateTypeSelected === 'Custom') {
        this.dateTypeSelected = 'Custom';
        this.enableDayRange = true;
        this.formData.startDate = this.jobFilters.startDate;
        this.formData.endDate = this.jobFilters.endDate;
      }
    },
  },
};
</script>

<style scoped>
.next-style,
.cancel-style {
  height: 30px !important;
  font-size: 12px;
  width: 80px;
  font-weight: lighter !important;
  text-transform: none !important;
}

.theme--dark.v-list {
  background-color: white !important;
}

.theme--dark >>> .v-list-item {
  color: #37474f !important;
}
</style>
